import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle2, XCircle, FileText, AlertCircle, Clock, FilePen } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SummaryBarProps {
  total: number;
  submitted: number;
  approved: number;
  rejected: number;
  recalled: number;
  drafts: number;
}

export const SummaryBar: React.FC<SummaryBarProps> = ({ total, submitted, approved, rejected, recalled, drafts }) => {

  const cards = [
    {
      label: 'Total Timesheets',
      value: total,
      icon: FileText,
      className: 'border-border',
      valueClass: 'text-foreground',
    },
    {
      label: 'Submitted',
      value: submitted,
      icon: Clock,
      className: 'border-info-200 dark:border-info-800',
      valueClass: 'text-info-700 dark:text-info-400',
    },
    {
      label: 'Approved',
      value: approved,
      icon: CheckCircle2,
      className: 'border-success-200 dark:border-success-800',
      valueClass: 'text-success-700 dark:text-success-400',
    },
    {
      label: 'Rejected',
      value: rejected,
      icon: XCircle,
      className: 'border-error-200 dark:border-error-800',
      valueClass: 'text-error-700 dark:text-error-400',
    },
    {
      label: 'Recalled',
      value: recalled,
      icon: AlertCircle,
      className: 'border-amber-200 dark:border-amber-800',
      valueClass: 'text-amber-700 dark:text-amber-400',
    },
    {
      label: 'Drafts',
      value: drafts,
      icon: FilePen,
      className: 'border-border',
      valueClass: 'text-muted-foreground',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-3">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <Card key={card.label} className={cn('border', card.className)}>
            <CardContent className="p-4">
              <div className="flex items-center gap-2 mb-1">
                <Icon className={cn('h-4 w-4', card.valueClass)} />
                <span className="text-xs font-medium text-muted-foreground">{card.label}</span>
              </div>
              <div className={cn('text-2xl font-bold', card.valueClass)}>{card.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
